export default {
  graphQLEndpoint: process.env.VUE_APP_GRAPHQL_ENDPOINT,
  serverEndpoint: process.env.VUE_APP_SERVER_ENDPOINT,
  graphQLWsEndpoint: process.env.VUE_APP_GRAPHQL_WS_ENDPOINT,
  landingPage: {},
  DEFAULT_TENANT_APPROVAL_WORKFLOW: 'DEFAULT TENANT APPROVAL WORKFLOW',
  TENANT_TYPE: {
    INDEPENDENT: 1,
    COLLABORATOR: 2
  },
  urlKeys: {
    useSessionStorage: 'useSessionStorage',
    tenantId: 'tenantId',
    projectId: 'projectId',
    redirectFrom: 'redirectFrom',
    targetTenantId: 'targetTenantId'
  },
  localstorageKeys: {
    AUTH: 'dtxtoken',
    TENANT: 'dtxTenantToken',
    PROJECT: 'dtxProjectToken',
    FACTORY: 'dtxFactoryToken',
    LAST_OPENED_PROJECT: 'projectId',
    LAST_OPENED_TENANT: 'tenantId',
    LAST_OPENED_FACTORY: 'factoryId',
    PROJECT_TOKEN_NAME: 'projectTokenMap',
    COLLABORATOR: 'collaborator',
    COLLABORATOR_ID: 'collaboratorId',
    TENANT_TYPE: 'tenantType',
    REDIRECT_FROM: 'redirectFrom',
    TARGET_TENANT_ID: 'targetTenantId',
    LAST_PATH: 'lastPath'
  },
  userRole: {
    1: 'Admin',
    2: 'Editor',
    3: 'Collaborator',
    4: 'Viewer'
  },
  USER_STATUS_MAP: {
    ACTIVE: 1,
    INACTIVE: 2,
    DELETED: 3,
    INVITED: 4
  },
  USER_ROLE_MAP: {
    ADMIN: 1,
    EDITOR: 2,
    COLLABORATOR: 3,
    VIEWER: 4,
    SUPERVISOR: 5
  },
  USER_ROLE_INVERTED_MAP: {
    1: 'ADMIN',
    2: 'EDITOR',
    3: 'COLLABORATOR',
    4: 'VIEWER',
    5: 'SUPERVISOR'
  },
  STATE_MAP: {
    1: 'LOCK',
    2: 'CHECKIN',
    3: 'CHECKOUT',
    4: 'OBSOLETE', // in be  state 4 represents Obsolete in BE
    5: 'RELEASED'
  },
  MATERIAL_STATUS_MAP: {
    1: 'ACTIVE',
    2: 'OBSELETE',
    // 3: 'HOLD',
    4: 'LOCKED',
    5: 'RELEASED'
  },
  MATERIAL_STATUS_INVERTED_MAP: {
    ACTIVE: 1,
    OBSELETE: 2,
    // HOLD: 3,
    LOCKED: 4,
    RELEASED: 5

  },
  TASK_TYPES: {
    1: 'task',
    2: 'project',
    3: 'milestone'
  },
  DOC_STATE: {
    1: 'LOCK',
    2: 'CHECKIN',
    3: 'CHECKOUT',
    4: 'OBSOLETE',
    5: 'RELEASE'
  },
  DOC_STATE_MAP: {
    LOCK: 1,
    CHECKIN: 2,
    CHECKOUT: 3,
    OBSOLETE: 4,
    RELEASE: 5
  },
  BOM_STATE_MAP: {
    LOCK: 1,
    CHECKIN: 2,
    CHECKOUT: 3,
    OBSOLETE: 4,
    RELEASE: 5
  },
  MATERIAL_TYPE: {
    1: 'Material',
    2: 'Resource'
  },
  MATERIAL_TYPE_INVERTED: {
    MATERIAL: 1,
    RESOURCE: 2
  },
  MATERIAL_TYPE_VALUE_NAME: {
    BUY: 'Buy',
    MAKE: 'Make'
  },
  MODULE_ROUTE: {
    FORM: 'form',
    PROJECTS: 'PROJECTS',
    DOCUMENTS: 'document-view',
    ITEM_MASTER: 'materialmaster',
    BOM: 'bom',
    PROJECT_PLANNER: 'project-planner',
    TIME_SHEET: 'timesheet',
    FORECAST: 'trendsandforecast',
    SETTINGS: 'settings',
    INSIGHTS: 'insights'
  },
  TAG_TYPE_MAP: {
    MATERIAL: 1,
    TASK: 2,
    FORM: 3
  },
  FORM_STATE: {
    1: 'OPEN',
    2: 'DRAFT',
    3: 'REOPENED',
    4: 'CLOSED',
    5: 'CANCELLED'
    // 6:'IN PROGRESS',
    // 7: 'APPROVED',
    // 8:'REJECTED',
    // 9:'HOLD',
  },
  FORM_STATE_MAP: {
    OPEN: 1,
    DRAFT: 2,
    REOPENED: 3,
    CLOSED: 4,
    CANCELLED: 5,
    IN_PROGRESS: 6,
    APPROVED: 7,
    REJECTED: 8,
    HOLD: 9
  },
  FORM_TAB_STATUS: {
    WORKFLOW: 1,
    COMMENTS: 2,
    REVISION_HISTORY: 3,
    HISTORY: 4,
    LINKED_ENTITIES: 5
  },
  WORKFLOW_STATE_NAMES: {
    NOT_STARTED: 'NOT_STARTED',
    ONGOING: 'ONGOING',
    COMPLETED: 'COMPLETED',
    REJECTED: 'REJECTED'
  },
  BEACON_DASHBOARD: {
    TEMPLATE_NAME: 'BEACONsales',
    TARGET_TEMPLATE_NAME: 'BEACONTarget',
    STAGING_TENANT_ID: 'f56a5367-218e-4b70-bc74-2aed5085c693'
  },
  STANDARD_MATERIAL_FORM: {
    name: 'Standard Material Form',
    form_type: 11 // this is the default form type id for standard material form
  },
  JOB_ORDER_FORM: {
    name: 'Job Order Form - JOF',
    form_type: 5
  },
  STANDARD_BOM_FORM: {
    name: 'Standard BOM Form',
    form_type: 12 // this is the default form type id for standard bom form
  },
  DOCUMENT_REVISIONING_FORM: {
    name: 'Document Revisioning Form',
    form_type: 14
  },
  SAFETY_CHECKLIST: {
    name: 'Safety Checklist',
    form_type: 15
  },
  QUALITY_CHECKLIST: {
    name: 'Quality Checklist',
    form_type: 16
  },
  PROCESS_CHECKLIST: {
    name: 'Process Checklist',
    form_type: 17
  },
  DOCUMENTATION_CHECKLIST: {
    name: 'Documentation Checklist',
    form_type: 18
  },
  ANNOTATION_TYPE: {
    4: 'path'
  },
  COLORS: [
    '#FF5733', '#33FF57', '#3357FF', '#FF33A1', '#A1FF33', '#5733FF', '#33FFF5', '#FF5733', '#F533FF', '#33FF57',
    '#57FF33', '#FF3357', '#33A1FF', '#33FF7F', '#7F33FF', '#FF7F33', '#33FFAF', '#AF33FF', '#FF33AF', '#AFF533',
    '#FF5733', '#5733FF', '#33FF7F', '#A1FF33', '#FF33F5', '#FF5733', '#33A1FF', '#F533FF', '#FF3357', '#7F33FF',
    '#FF7F33', '#AF33FF', '#33FFAF', '#AFF533', '#33FF57', '#5733FF', '#57FF33', '#FF3357', '#33A1FF', '#33FF7F',
    '#7F33FF', '#FF33F5', '#FF7F33', '#33FFAF', '#AFF533', '#FF5733', '#5733FF', '#A1FF33', '#F533FF', '#FF3357',
    '#33FF57', '#FF5733', '#33A1FF', '#7F33FF', '#33FF7F', '#FF33AF', '#33FFAF', '#AFF533', '#FF5733', '#5733FF',
    '#57FF33', '#FF3357', '#33A1FF', '#FF7F33', '#AF33FF', '#FF33F5', '#33FF57', '#FF5733', '#F533FF', '#33FF7F',
    '#7F33FF', '#FF33AF', '#AFF533', '#FF5733', '#33FFAF', '#FF5733', '#5733FF', '#A1FF33', '#FF33F5', '#33FF57',
    '#FF5733', '#33A1FF', '#F533FF', '#FF3357', '#7F33FF', '#FF7F33', '#AF33FF', '#33FFAF', '#AFF533', '#FF5733'
  ],
  CORE_FEATURES: {
    MATERIAL: 1,
    BOM: 2,
    DOCUMENTS: 3,
    TASKS: 4,
    FORMS: 5,
    PRODUCT_CODE: 6,
    USERS: 7,
    CHECKLIST: 10,
    TENANT: 11,
    FACTORY: 12
  },
  WORKFLOW_SUB_CATE: {
    PROCESS_PLAN: 1,
    ALTERNATE_MATERIAL: 2,
    LIFECYCLE: 3,
    DOCUMENT_REVISIONING: 4,
    TENANT_APPROVAL: 5,
    FORM_PROCESS: 6

  },
  CORE_FEATURES_INVERTED:
    {
      1: 'MATERIAL',
      2: 'BOM',
      3: 'DOCUMENTS',
      4: 'TASKS',
      5: 'FORMS',
      6: 'PRODUCT_CODE',
      7: 'USERS',
      11: 'TENANT'
    },
  NODE_TYPE: { PHASE: 1, STEP: 2 },
  WORKFLOW_TYPE: {
    ONLY_STEPS: 'NORMAL',
    STEPS_WITH_PHASES: 'PARTIAL',
    FULL: 'FULL'
  },
  FORM_TYPE: {
    TEXT: 1,
    LONG_TEXT: 2,
    NUMBER: 3,
    CONFIGRATION_LIST: 4,
    COMPANY: 5,
    ATTACHMENT: 6,
    DATE: 7,
    TIME: 8,
    USER: 9,
    MULTI_USER: 10,
    MULTI_COMPANY: 11,
    BOOLEAN: 12,
    LOCATION: 13,
    MATERIALS: 14,
    PRODUCT_CODE: 15,
    DOCUMENTS: 19,
    TABLE: 20
  },
  FORM_TEMPLATE_TYPE: {

    SBF: 12,
    MDF: 2,
    DRF: 14,
    AOF: 6,
    MRF: 1,
    GRN: 3,
    SMF: 11,
    INS: 4,
    JOF: 5,
    AIF: 7,
    SIF: 9,
    QCF: 10,
    COF: 8
  },
  SAFETY_CHECKLIST_FORM: {
    name: 'Safety Checklist Form',
    form_type: 15
  },
  QUALITY_CHECKLIST_FORM: {
    name: 'Quality Checklist Form',
    form_type: 16
  },
  PROCESS_CHECKLIST_FORM: {
    name: 'Process Checklist Form',
    form_type: 17
  },
  DOCUMENTATION_CHECKLIST_FORM: {
    name: 'Documentation Checklist Form',
    form_type: 18
  },
  elementColor: {
    green: '66, 128, 47', // #42802f
    orange: '173, 119, 57', // #ad7739
    blue: '61, 75, 145', // #3d4b91
    purple: '156, 81, 128', // #9c5180
    red: '252, 86, 88' // #fc5658
  },
  DURATION_TYPE: {
    1: 'Days',
    2: 'Hours',
    3: 'Minutes'
  },
  MATERIAL_WORKFLOW_STATUS: {
    1: 'ONGOING',
    2: 'NOT STARTED',
    4: 'COMPLETED'
  },
  DEFAULT_QC_FIELD_ID_MAPS: {
    PART_NAME: 'ad093b6f-7e2c-446a-a8e6-02303c18bbf2',
    PART_NUMBER: '41483407-d66e-4acf-ada3-3664d071a8da',
    OPERATION: '829dfd58-5df9-43f1-962a-f0c7a1aae722',
    INSPECTOR: '0b86029d-f645-483d-815a-7e01f4fa832b'
  },
  MATERIAL_TYPES: {
    Make: 6895,
    Buy: 6896
  },
  DURATION_TYPE_REVERSE_MAP: {
    Days: 1,
    Hours: 2,
    Minutes: 3,
    Quarterly: 4,
    Yearly: 5
  },
  FACTORY_FIELD_ID: '5df86e02-d390-43b6-9909-94f8c1c0ca38',
  WORKFLOW_TYPES: {
    1: 'Process Plan',
    2: 'Alternate Material',
    3: 'Lifecycle',
    4: 'Document Revisioning',
    5: 'Tenant Approval',
    6: 'Form Process'
  },
  WORKFLOW_TYPES_INVERTED: {
    PROCESS_PLAN: 1,
    ALTERNATE_MATERIAL: 2,
    LIFECYCLE: 3,
    DOCUMENT_REVISIONING: 4,
    TENANT_APPROVAL: 5,
    FORM_PROCESS: 6
  },
  IMPORT_STATUS: {
    NONE: 1,
    PROCESSING: 2,
    WARNING: 3,
    ERROR: 4,
    SUCCESS: 5
  }
}
